import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'eng',
    debug: true,
    preload: ['eng'],
    ns: ['translation'],
    defaultNS: 'translation',
    keySeparator: '-',
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
    react: {
      wait: true,
    },
  });

export default i18n;
